import Pinned from './Pinned';

export default Pinned;
